import React, { useState, useEffect } from "react";
import FileAuditUploadService from "../../../services/fileAuditUpload.service";
import { Image } from "react-bootstrap";

interface ImageDisplayProps {
  questionId: number;
}

function ImageDisplay({ questionId }: ImageDisplayProps) {
  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);
      setError("");
      try {
        const files = await FileAuditUploadService.getFilesQuestion(questionId);
        setImageUrls(
          files.map((file) => {
            return (
              file.shareableUrl
                .replace("www.dropbox.com", "dl.dropboxusercontent.com")
                .split("?")[0] +
              `?rlkey=${file.shareableUrl.split("rlkey=")[1].split("&")[0]}`
            );
          })
        );
      } catch (err) {
        setError("Error al cargar las imágenes");
        console.error("Error fetching images:", err);
      } finally {
        setLoading(false);
      }
    };

    if (questionId) {
      fetchImages();
    } else {
      setImageUrls([]);
      setLoading(false);
    }
  }, [questionId]);

  if (loading) {
    return <div>Cargando imágenes...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div>
      {imageUrls.map((url, index) => (
        <Image
          key={index}
          src={url}
          alt={`Imagen ${index + 1}`}
          fluid // Esta es la prop clave para la responsividad
          className="mx-auto d-block my-2" // Clases para centrar y añadir margen
        />
      ))}
      {imageUrls.length === 0 && !loading && (
        <p>No hay imágenes para mostrar.</p>
      )}
    </div>
  );
}

export default ImageDisplay;
